import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { updateContact } from 'bundles/apex/deals/show/store/deal/actions';

import FormModal from 'bundles/backoffice/contacts/forms/modal';

export function ContactFormModal({ contact, features, show, updateContact, voucherId, onHide }) {
  const handleUpdateContact = (updatedContact) => {
    updateContact(updatedContact);
    onHide();
  };

  return (
    <FormModal
      allowTagging={features.crmTags}
      contact={contact}
      contactType={contact.contactType}
      forceSaveAsRoot={features.contactsV2}
      multipleBusinesses={features.contactsV2}
      show={show}
      voucherId={voucherId}
      warn={features.contactsV2}
      onCancel={onHide}
      onSave={handleUpdateContact}
    /> 
  );
}

ContactFormModal.propTypes = {
  contact: PropTypes.shape({
    contactType: PropTypes.string.isRequired,
    id: PropTypes.number,
  }).isRequired,
  features: PropTypes.shape({
    crmTags: PropTypes.bool,
  }).isRequired,
  show: PropTypes.bool,
  updateContact: PropTypes.func.isRequired,
  voucherId: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  features: state.features,
  voucherId: state.deal.voucherId,
});

const mapDispatchToProps = {
  updateContact
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactFormModal);
